import {
  Producto, ProductoCreate, ProductoUpdate, Autor, AutorCreate, AutorUpdate,
  Noticia, NoticiaCreate, NoticiaUpdate,
  Usuario
} from '../types';

//const API_BASE = 'http://localhost:8060'
const API_BASE = 'https://servicios.algoritmojuridico.com';

// Use /api prefix in development (localhost) to work with proxy
// In production, use the full backend URL
console.log("API_BASE: ", API_BASE);
// Helper para obtener headers con autenticación
const getAuthHeaders = (): HeadersInit => {
  const token = localStorage.getItem('auth_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

const handleResponse = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    // Si es 401, el token expiró o es inválido
    if (response.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      window.location.href = '/login';
    }
    const errorText = await response.text().catch(() => 'Error desconocido');
    throw new Error(`Error ${response.status}: ${errorText}`);
  }
  return response.json();
};


export const api = {
  productos: {
    list: (): Promise<Producto[]> =>
      fetch(`${API_BASE}/productos`, {
        headers: getAuthHeaders()
      }).then(r => handleResponse<Producto[]>(r)),
    create: (data: FormData): Promise<Producto> =>
      fetch(`${API_BASE}/productos`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: data,
      }).then(r => handleResponse<Producto>(r)),
    update: (id: number, data: FormData): Promise<Producto> =>
      fetch(`${API_BASE}/productos/${id}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: data,
      }).then(r => handleResponse<Producto>(r)),
    delete: (id: number): Promise<void> =>
      fetch(`${API_BASE}/productos/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      }).then(r => r.ok ? Promise.resolve() : Promise.reject(new Error('Delete failed'))),
  },
  autores: {
    list: (): Promise<Autor[]> =>
      fetch(`${API_BASE}/autores`, {
        headers: getAuthHeaders()
      }).then(r => handleResponse<Autor[]>(r)),
    create: (data: FormData): Promise<Autor> =>
      fetch(`${API_BASE}/autores/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: data,
      }).then(r => handleResponse<Autor>(r)),
    update: (id: number, data: FormData): Promise<Autor> =>
      fetch(`${API_BASE}/autores/${id}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: data,
      }).then(r => handleResponse<Autor>(r)),
    delete: (id: number): Promise<void> =>
      fetch(`${API_BASE}/autores/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      }).then(r => r.ok ? Promise.resolve() : Promise.reject(new Error('Delete failed'))),
  },

  noticias: {
    list: (): Promise<Noticia[]> =>
      fetch(`${API_BASE}/noticias`, {
        headers: getAuthHeaders()
      }).then(r => handleResponse<Noticia[]>(r)),
    create: (data: FormData): Promise<Noticia> =>
      fetch(`${API_BASE}/noticias`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: data,
      }).then(r => handleResponse<Noticia>(r)),
    update: (id: number, data: FormData): Promise<Noticia> =>
      fetch(`${API_BASE}/noticias/${id}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: data,
      }).then(r => handleResponse<Noticia>(r)),
    delete: (id: number): Promise<void> =>
      fetch(`${API_BASE}/noticias/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      }).then(r => r.ok ? Promise.resolve() : Promise.reject(new Error('Delete failed'))),
  },

  usuarios: {
    list: (): Promise<Usuario[]> =>
      fetch(`${API_BASE}/usuarios_list`, {
        headers: getAuthHeaders()
      }).then(r => handleResponse<Usuario[]>(r)),
    update: (id: number, data: any): Promise<any> =>
      fetch(`${API_BASE}/usuarios/${id}`, {
        method: 'PUT',
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
      }).then(r => handleResponse<Usuario>(r)),
  },
};
